<div class="copyright">
  @if (copyRightText() | optionalAsync; as copyright) {
    <span class="copyright__name">{{ copyright }}</span>
    <span class="copyright__separator">–</span>
  }
  <span class="copyright__year">{{ year }}</span>
</div>
